import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var listItemMediaClassName = 'ui-list__itemmedia';

/**
 * Provides a content for the ListItem.
 */
export var ListItemMedia = /*#__PURE__*/function () {
  var ListItemMedia = compose(Box, {
    className: listItemMediaClassName,
    displayName: 'ListItemMedia',
    mapPropsToStylesProps: function mapPropsToStylesProps(_ref) {
      var hasContent = _ref.hasContent,
        hasHeader = _ref.hasHeader,
        important = _ref.important;
      return {
        hasContent: hasContent,
        hasHeader: hasHeader,
        important: important
      };
    },
    handledProps: ['hasContent', 'hasHeader', 'important'],
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  ListItemMedia.propTypes = commonPropTypes.createCommon();
  return ListItemMedia;
}();
//# sourceMappingURL=ListItemMedia.js.map
